import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'lv-instana',
    template: '',
    standalone: false
})
export class InstanaComponent implements OnInit {

  @Input()
  public instanaUrl: string;

  constructor() { }

  ngOnInit(): void {
    const s1 = document.createElement('script');
    s1.innerText = '(function(s,t,a,n){s[t]||(s[t]=a,n=s[a]=function(){n.q.push(arguments)},\n' +
        '        n.q=[],n.v=2,n.l=1*new Date)})(window,"InstanaEumObject","ineum");\n' +
        '    ineum(\'reportingUrl\', \'' + this.instanaUrl + '/eum/\');\n' +
        '    ineum(\'key\', \'vsAK2VMYSwexp6ZM0fqJ5Q\');\n' +
        '    ineum(\'trackSessions\');';
    document.head.appendChild(s1);
    const s2 = document.createElement('script');
    s2.defer = true;
    s2.crossOrigin = 'anonymous';
    s2.src = this.instanaUrl + '/eum/eum.min.js';
    document.head.appendChild(s2);
  }

}
